import React from 'react';

import DeliveryRoutesTable from '../components/delivery-page/deliveryRoutesTable';

class DeliveryRoutes extends React.Component{
	render(){
		return (
			<div style={{ margin: 16 }}>
                <DeliveryRoutesTable />
			</div>
		)
	}

}

export default DeliveryRoutes


// WEBPACK FOOTER //
// ./src/containers/delivery-routes.js